import React from "react";
import { Row, Col, Modal, Button } from "antd";
import styles from "../DashBoard.module.scss";
import { TrackAnalytics } from "../../../types/ApplicationTypes";
import { useTripActions } from "../../../hooks/useTripActions";
import { ITripDetails } from "../../ServiceUsers/Interfaces/ITripDetails";
import { useTripsCtx } from "../../../context/TripDetailsContext";

type Props = {
  visible: boolean;
  setVisibility: Function;
  handleYesCancel: () => void;
};

function CancelTripModal({ visible, setVisibility, handleYesCancel }: Props) {
  function handleClose() {
    setVisibility(false);
  }

  return (
    <Modal
      visible={visible}
      className={styles.modalContainer}
      footer={
        <Row justify="center" gutter={[10, 10]} className={styles.modalBtns}>
          <Col>
            <Button className={styles.modalCloseBtn} onClick={handleClose}>
              Close
            </Button>
          </Col>
          <Col>
            <Button className={styles.modalYesBtn} onClick={handleYesCancel}>
              Yes, Cancel
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center">
        <Col className={styles.modalHeading}>Cancel Service</Col>
      </Row>
      <Row justify="center" className={styles.modalContent}>
        <Col>
          Are you sure you want to cancel this service?
          <br /> This cannot be undone.
        </Col>
      </Row>
    </Modal>
  );
}

export default CancelTripModal;
